import profileApi from '../../api/profile'

// initial state
const state = {
  filterPresets: []
}

const getters = {
}

const actions = {
  get ({ commit }) {
    return new Promise((resolve, reject) => {
      profileApi.get(profile => {
        resolve(profile)
      },
      error => {
        reject(error)
      })
    })
  },

  getUserID ({ commit }, userID) {
    return new Promise((resolve, reject) => {
      profileApi.getUserID(userID, profile => {
        resolve(profile)
      },
      error => {
        reject(error)
      })
    })
  },

  update ({ commit }, params) {
    return new Promise((resolve, reject) => {
      profileApi.update({
        profile: params
      },
      profile => {
        resolve(profile)
      },
      error => {
        reject(error)
      })
    })
  },

  getFilterSets({commit}, params) {
    return new Promise((resolve, reject) => {
      profileApi.getFilterSets(params,
      set => {
        commit('setFilterPresets', set)
        resolve(set)
      },
      error => {
        reject(error)
      })
    })
  },

  saveFilterSet({commit}, params) {
    return new Promise((resolve, reject) => {
      profileApi.saveFilterSet(params,
      set => {
        commit('addFilterPreset', set)
        resolve(set)
      },
      error => {
        reject(error)
      })
    })
  },

  deleteFilterSet({commit}, params) {
    console.log('p ', params)
    return new Promise((resolve, reject) => {
      profileApi.deleteFilterSet(params.presetID,
      set => {
        commit('removeFilterPreset', params.presetID)
        resolve(set)
      },
      error => {
        reject(error)
      })
    })
  },
}

const mutations = {
  setFilterPresets(state, presets) {
    state.filterPresets = presets
  },
  addFilterPreset(state, presets) {
    state.filterPresets.push(presets)
  },
  removeFilterPreset(state, presetID) {
    state.filterPresets = state.filterPresets.filter((fp) => fp.id === presetID)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
